<template>
  <div class="row justify-content-center px-4">
    <div class="form-group col-md-6 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <address-fields
        :address="addressObject"
        :value="applicationData.fullAddress"
        :readonly="readonly"
        @update="onAddressUpdate" />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import AddressFields from '@/shared/address_fields.vue'

export default {
  components: {
    AddressFields
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    addressObject() {
      return {
        address: this.applicationData.address,
        address2: this.applicationData.address2,
        city: this.applicationData.city,
        state: this.applicationData.state,
        zip_code: this.applicationData.zip_code
      }
    }
  },
  methods: {
    onAddressUpdate({
      field,
      value
    }) {
      Vue.set(this.applicationData, field, value)
    },
  }
}
</script>
